import gmrm from 'googlemaps-rich-marker-web';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import styles from './map.module.scss';

import FocusIcon from '../assets/LocationOnly';

const mapStyles = require('./lib/styles.json');

const MAX_ZOOM = 16;
const MIN_ZOOM = 16;

const LATITUDE = 40.716947;
const LONGITUDE = -73.983198;

const NE_BOUNDS_LAT = 40.724476648050285; //north, y
const NE_BOUNDS_LNG = -73.96517355541994; //east, x
const SW_BOUNDS_LAT = 40.709416500218396; //south, y
const SW_BOUNDS_LNG = -74.0012224445801; //west, x

const LOCATION = 'location';
const TAP = 'tap';

//create promise for getCurrentPosition
const getPositionPromise = () => {
  if (navigator.geolocation) {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
      })
    );
  } else {
    console.log("Browser doesn't support Geolocation");
    return new Promise(resolve => resolve(), reject);
  }
};

const FocusButton = ({ stopSelectionMethod, onClick }) => (
  <div
    className={`${styles.focusButton} ${
      stopSelectionMethod === LOCATION ? styles.focusActive : ''
    }`}
    onClick={onClick}
  >
    <div className={styles.focusIconContainer}>
      <FocusIcon />
    </div>
  </div>
);

class GoogleMap extends Component {
  state = {
    hasRequestedLocation: false,
    doesMapExist: false,
  };

  mapBounds = {
    north: NE_BOUNDS_LAT,
    east: NE_BOUNDS_LNG,
    south: SW_BOUNDS_LAT,
    west: SW_BOUNDS_LNG,
  };

  map = null;
  mapRef = null;
  gmBounds = null;
  LESBounds = null;
  lastValidCenter = null;
  blueDot = null;
  currLocation = null;
  initalLocation = null;
  userInLowEastSide;

  isLocationInLowerEastSide = (lat, lng) => {
    return (
      lat > this.mapBounds.south &&
      lat < this.mapBounds.north &&
      (lng > this.mapBounds.west && lng < this.mapBounds.east)
    );
  };

  getInitialLocation = () => {
    //check for current position
    getPositionPromise()
      .then(position => {
        const { Maps } = this.props;

        const initPosition = new Maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );

        if (
          this.isLocationInLowerEastSide(initPosition.lat(), initPosition.lng())
        ) {
          // if (this.map.getBounds().contains(initPosition)) {
          this.createBlueDot(initPosition, true);
        } else {
          console.log('out of bounds');
          this.props.setDefaultActivePin();
        }
      })
      .catch(err => {
        throw err;
      });
  };

  setCurrentLocation = (lat, lng) => {
    this.currLocation = {
      lat: lat,
      lng: lng,
    };
  };

  createBlueDot = (position, startUpdate = false) => {
    if (this.blueDot) return;
    const { Maps, getDotLocationForMap } = this.props;

    this.setCurrentLocation(position.lat(), position.lng());

    this.blueDot = new gmrm.RichMarker({
      position: new Maps.LatLng(this.currLocation.lat, this.currLocation.lng),
      content: '',
      shadow: 'none',
      map: this.map,
    });

    if (!this.blueDot.content.length) {
      this.blueDot.setContent(this.getDotContent());
    }

    getDotLocationForMap(this.currLocation);

    if (startUpdate) {
      this.updateBlueDot();
    }
  };

  updateBlueDot = () => {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(
        position => {
          this.setLocation(position);
        },
        err => {
          console.log(err);
          throw err;
        },
        { enableHighAccuracy: true }
      );
    } else {
      console.log("Browser doesn't support Geolocation");
    }
  };

  getDotContent = currLocation => {
    const content =
      "<div class='dot'><div class='shadow'></div><div class='innerCircle'></div><div class='outerCircle'></div></div>";
    return content;
  };

  setLocation = position => {
    const { Maps, getDotLocationForMap } = this.props;

    this.setCurrentLocation(
      position.coords.latitude,
      position.coords.longitude
    );

    if (!this.blueDot) {
      this.createBlueDot(this.currLocation);
    } else {
      this.blueDot.setPosition(
        new Maps.LatLng(this.currLocation.lat, this.currLocation.lng)
      );
    }

    if (this.props.stopSelectionMethod === LOCATION) {
      getDotLocationForMap(this.currLocation);
      this.map.panTo(this.blueDot.getPosition());
    }
  };

  panToOffsetCenter = (latlng, { x, y }, shouldPan = true) => {
    const { Maps } = this.props;
    let scale = Math.pow(2, this.map.getZoom());

    let worldCoordinate = this.map.getProjection().fromLatLngToPoint(latlng);

    let pixelOffset = new Maps.Point(
      parseFloat(x) / scale || 0,
      parseFloat(y) / scale || 0
    );

    let worldCoordinateNewCenter = new Maps.Point(
      worldCoordinate.x - pixelOffset.x,
      worldCoordinate.y + pixelOffset.y
    );

    let newCenter = this.map
      .getProjection()
      .fromPointToLatLng(worldCoordinateNewCenter);

    if (shouldPan) {
      this.map.panTo(newCenter);
    } else {
      this.map.setCenter(newCenter);
    }
  };

  setLastValidCenter = () => {
    if (this.gmBounds.contains(this.map.getCenter())) {
      // console.log(this.gmBounds.contains(this.map.getCenter()));
      this.lastValidCenter = this.map.getCenter();
      return;
    }
  };

  remainInBounds = () => {
    // let zoom = this.map.getZoom();
    // let projection = this.map.getProjection();
    // let NEPx = projection.fromLatLngToPixel(this.gmBounds.getNorthEast(), zoom);
    // let SWPx = projection.fromLatLngToPixel(this.gmBounds.getSouthWest(), zoom);
    // console.log(NEPx, SWPx);
    // if (!this.gmBounds.contains(this.map.getCenter())) {
    //   this.panToOffsetCenter(
    //     this.lastValidCenter,
    //     this.getPixelOffsetToOffsetCenter(this.mapRef)
    //   );
    // }
  };

  getPixelOffsetToOffsetCenter = mapRef => {
    const { isMobileDevice } = this.props;
    let riverWidth = !isMobileDevice
      ? mapRef.getBoundingClientRect().width * 0.3
      : 0;
    let paddingRight = !isMobileDevice ? 25 : 0;
    let paddingTop = 115;
    let paddingBottom = !isMobileDevice ? 40 : 165;

    let pixelCenter = {
      x: mapRef.getBoundingClientRect().width * 0.5,
      y: mapRef.getBoundingClientRect().height * 0.5,
    };

    let offsetCenter = {
      x:
        (mapRef.getBoundingClientRect().width - (riverWidth + paddingRight)) *
        0.5,
      y: mapRef.getBoundingClientRect().height * 0.5,
    };

    return {
      x: offsetCenter.x - pixelCenter.x,
      y: offsetCenter.y - pixelCenter.y,
    };
  };

  drawDebugRect = () => {
    //Add debug rectangle around markers
    const debugRectangle = new google.maps.Rectangle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      map: this.map,
      bounds: this.gmBounds,
    });
  };

  loadMap = mapRef => {
    if (this.props && this.props.Maps) {
      const { Maps } = this.props;

      //const maps = google.maps;
      const node = ReactDOM.findDOMNode(mapRef);
      const center = new Maps.LatLng(LATITUDE, LONGITUDE);

      //set bounds
      this.gmBounds = new Maps.LatLngBounds();

      //extend bounds to fit markers
      this.props.markers.map(marker => {
        const markerPosition = new Maps.LatLng(
          marker.map_data.lat,
          marker.map_data.lng
        );

        if (
          /*set this check to true to test on site*/
          this.isLocationInLowerEastSide(
            markerPosition.lat(),
            markerPosition.lng()
          )
        ) {
          this.gmBounds.extend(markerPosition);
        }
      });

      const mapConfig = {
        center: this.gmBounds.getCenter(),
        zoom: MIN_ZOOM,
        maxZoom: MAX_ZOOM,
        minZoom: MIN_ZOOM,
        styles: [
          ...mapStyles,
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }],
          },
        ],
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        zoomControl: false,
        disableDefaultUI: true,
        gestureHandling: 'greedy',
        zoomControlOptions: {
          position: Maps.ControlPosition.LEFT_BOTTOM,
        },
      };

      this.map = new Maps.Map(node, mapConfig);

      //set the last valid center
      this.lastValidCenter = this.map.getCenter();

      // this.drawDebugRect();

      // const marker = new google.maps.Marker({
      //   position: this.map.getCenter(),
      //   map: this.map,
      // });

      // const neMarker = new google.maps.Marker({
      //   position: this.gmBounds.getNorthEast(),
      //   map: this.map,
      // });

      // const swMarker = new google.maps.Marker({
      //   position: this.gmBounds.getSouthWest(),
      //   map: this.map,
      // });

      Maps.event.addListenerOnce(this.map, 'idle', () => {
        this.panToOffsetCenter(
          this.map.getCenter(),
          this.getPixelOffsetToOffsetCenter(this.mapRef)
        );
      });

      if (typeof window !== undefined) {
        Maps.event.addDomListener(window, 'resize', () => {
          this.panToOffsetCenter(
            this.lastValidCenter,
            this.getPixelOffsetToOffsetCenter(this.mapRef),
            false
          );
        });
      }

      //event logic
      Maps.event.addListener(this.map, 'dragstart', () => {
        this.props.handleSetSelectionMethod(TAP);
      });

      Maps.event.addListener(this.map, 'drag', () => {
        this.setLastValidCenter();
      });

      // Maps.event.addListener(this.map, 'dragend', () => {
      //   this.remainInBounds();
      // });

      // Maps.event.addListener(this.map, 'click', event => {
      //   console.log('map', event);
      //   this.blueDot.setPosition(event.latLng);
      //   this.setCurrentLocation(event.latLng.lat(), event.latLng.lng());
      //   this.props.getDotLocationForMap(this.currLocation);
      // });

      this.setState({ doesMapExist: true });
    }
  };

  handleFollowTheDot = () => {
    const { getDotLocationForMap } = this.props;
    if (this.blueDot && this.map) {
      this.props.handleSetSelectionMethod(LOCATION);
      this.map.panTo(this.blueDot.getPosition());
      getDotLocationForMap(this.currLocation);
    }
  };

  componentWillMount() {
    if (!this.props.shouldRequestLocation && this.props.hasRequestedLocation) {
      this.props.setDefaultActivePin();
    }
  }

  componentDidMount() {
    if (!this.props.isMobileDevice) {
      this.props.setDefaultActivePin();
    }
    this.loadMap(this.mapRef);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.Maps &&
      this.props.shouldRequestLocation !== prevProps.shouldRequestLocation
    ) {
      if (
        this.props.shouldRequestLocation &&
        !this.state.hasRequestedLocation
      ) {
        console.log('should request location');
        this.getInitialLocation();
        this.setState({ hasRequestedLocation: true });
      } else {
        console.log('should not request location');
        this.setState({ hasRequestedLocation: true });
      }
    }
  }

  componentWillUnmount() {
    if (typeof window !== undefined) {
      this.props.Maps.event.clearListeners(this.map, 'click');
      this.props.Maps.event.clearListeners(this.map, 'dragend');
      this.props.Maps.event.clearListeners(this.map, 'dragstart');
      this.props.Maps.event.clearListeners(this.map, 'drag');
      this.props.Maps.event.clearListeners(window, 'resize');
    }
  }

  render() {
    const { children, Maps, shouldRequestLocation } = this.props;
    return (
      <React.Fragment>
        <div ref={el => (this.mapRef = el)} className={styles.mapContainer}>
          {children.length &&
            this.state.doesMapExist &&
            Maps &&
            React.Children.map(children, child =>
              React.cloneElement(child, {
                Maps,
                map: this.map,
              })
            )}
        </div>
        {shouldRequestLocation &&
          this.blueDot && (
            <FocusButton
              onClick={this.handleFollowTheDot}
              stopSelectionMethod={this.props.stopSelectionMethod}
            />
          )}
      </React.Fragment>
    );
  }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/tour/map/GoogleMap.js